import type { OriginFileKind } from "../../enums/scrape";
import type { MetricKey } from "../../report/catalog";
import { METRIC_KEY } from "../../report/catalog";

/**
 * Origin-resource issue identity. A finding tagged with an origin resource
 * (robots.txt / llms.txt) takes the resource — not its criterion — as its
 * issue subject, so one origin defect stays one issue across pages and
 * dimensions. The `origin.<kind>-txt` shape is colon-free (the
 * `yeet:<subject>:<problemKey>` fingerprint still splits unambiguously) and
 * cannot collide with snake_case metric keys or dotted subcriterion keys.
 */

export function originSubjectKey(kind: OriginFileKind): string {
  return `origin.${kind}-txt`;
}

/** Deterministic owning metric per resource — never the finding's dimension. */
export const ORIGIN_ISSUE_METRIC_KEYS: Record<OriginFileKind, MetricKey> = {
  robots: METRIC_KEY.INCLUSION,
  llms: METRIC_KEY.INCLUSION,
};

export const ORIGIN_RESOURCE_PATHS: Record<OriginFileKind, string> = {
  robots: "/robots.txt",
  llms: "/llms.txt",
};
